import type { Animation } from "../../engine/animation/AnimationQueue";
import { TIMING } from "../../config/constants";
import type { UnitVisual } from "../UnitVisual";

export class HealFlashVFX implements Animation {
  private elapsed = 0;
  private duration = TIMING.hitFlash;

  constructor(private visual: UnitVisual) {}

  update(dt: number): void {
    this.elapsed = Math.min(this.elapsed + dt, this.duration);
    this.visual.healFlash = Math.max(0, 1 - this.elapsed / this.duration);
  }

  isDone(): boolean {
    return this.elapsed >= this.duration;
  }

  onEnd(): void {
    this.visual.healFlash = 0;
  }
}
